module.exports = __webpack_public_path__ + "img/24217653000195.0419cd34.png";